module.exports = __webpack_public_path__ + "static/media/a63.e0439782.jpg";